/** @ngInject */
export function Controller(
    $state,
    $timeout,
) {
    this.$onInit = () => {

        var initIntegrationOverviewTab = function(){
            $('#federateSsoLink').click(function(event) {
                event.preventDefault();
                $state.go('^.configure-sso');
            });
            $('#manualConfigurationLink').click(function(event) {
                event.preventDefault();
                $state.go('^.manual-integration');
            });
            $('.userProvisioningLink').click(function(event) {
                event.preventDefault();
                $state.go('^.^.user-provisioning');
            });            
            $('#userAccountsLink').click(function(event) {
                event.preventDefault();
                $state.go('^.^.users');
            });
            
            $('#goToConfiguration').click(event => {
                event.preventDefault();
                $state.go('company.manage-application.configuration');
            });
			$('#usersLink').click(function(event){
	        event.preventDefault();
	        $state.go($state.current, {'#': 'users'});
			} ) ;
            $()
        };
        
        $timeout( function(){ 
            initIntegrationOverviewTab();     
        }, 200);
        this.m365txt=window.env.urls.m365txt;
        this.m365ps1=window.env.urls.m365ps1;
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/integration-office-365/integration-office-365.controller.js